import configurations from './reducers';

export { default as configurationsActions } from './actions';
export { default as configurationsTypes }   from './types';

export default configurations;